(() => {
  const normalize = (value) => String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  const manualContent = {
    iphone: { esim: 'Settings → Cellular → Add eSIM', lock: 'Settings → General → About → Carrier Lock' },
    samsung: { esim: 'Settings → Connections → SIM Manager → Add eSIM', lock: 'Contact the carrier that sold your phone' },
    pixel: { esim: 'Settings → Network & internet → SIMs → Add SIM', lock: 'Contact the carrier that sold your phone' },
    android: { esim: 'Dial *#06# and look for an EID, or check SIM settings', lock: 'Contact the carrier that sold your phone' }
  };

  const initialize = (root) => {
    if (!root || root.dataset.skyDeviceReady === 'true') return;
    const devices = Array.isArray(window.SkySimoDevices) ? window.SkySimoDevices : [];
    if (!devices.length) {
      root.dataset.skyDeviceWaiting = 'true';
      const attempts = Number(root.dataset.skyDeviceAttempts || 0) + 1;
      root.dataset.skyDeviceAttempts = String(attempts);
      if (attempts < 25) setTimeout(() => initialize(root), 120);
      else {
        const unavailable = root.querySelector('[data-device-list-empty]');
        if (unavailable) {
          unavailable.textContent = 'Device data could not be loaded. Please refresh the page or contact support.';
          unavailable.hidden = false;
        }
      }
      return;
    }
    root.dataset.skyDeviceReady = 'true';
    delete root.dataset.skyDeviceWaiting;
    delete root.dataset.skyDeviceAttempts;
    const search = root.querySelector('[data-device-search]');
    const clear = root.querySelector('[data-device-clear]');
    const suggestions = root.querySelector('[data-device-suggestions]');
    const welcome = root.querySelector('[data-device-welcome]');
    const result = root.querySelector('[data-device-result]');
    const status = root.querySelector('[data-device-status]');
    const statusLabel = root.querySelector('[data-device-status-label]');
    const statusTitle = root.querySelector('[data-device-status-title]');
    const statusNote = root.querySelector('[data-device-status-note]');
    const deviceName = root.querySelector('[data-device-name]');
    const deviceBrand = root.querySelector('[data-device-brand]');
    const regions = root.querySelector('[data-device-regions]');
    const cta = root.querySelector('[data-device-cta]');
    const manualButton = root.querySelector('[data-device-manual]');
    const brandsRoot = root.querySelector('[data-device-brands]');
    const listEmpty = root.querySelector('[data-device-list-empty]');
    const manualDetails = root.querySelector('[data-manual-details]');
    let selected = null;

    const deviceHaystack = (device) => normalize(`${device.brand} ${device.name} ${(device.aliases || []).join(' ')}`);
    const effectiveStatus = (device) => {
      const region = root.querySelector('[name^="device-region-"]:checked')?.value || 'us';
      if (device.status === 'unsupported') return 'unsupported';
      if ((device.unsupportedRegions || []).includes(region)) return 'restricted';
      if (device.status === 'conditional') return 'conditional';
      return 'supported';
    };
    const renderResult = () => {
      if (!selected) return;
      const state = effectiveStatus(selected);
      status.className = `sky-checker-result__status is-${state}`;
      deviceName.textContent = selected.name;
      deviceBrand.textContent = selected.brand;
      statusNote.textContent = state === 'unsupported'
        ? 'This model does not include eSIM support.'
        : selected.regionNote || 'Always confirm the options shown in your device settings.';
      const hasRegionalRule = selected.status === 'conditional' || Boolean(selected.regionNote) || (selected.unsupportedRegions || []).length > 0;
      regions.hidden = !hasRegionalRule;
      cta.hidden = !['supported', 'conditional'].includes(state);
      cta.classList.toggle('is-ready', !cta.hidden);
      cta.setAttribute('aria-disabled', String(cta.hidden));

      if (state === 'supported') {
        statusLabel.textContent = 'eSIM supported';
        statusTitle.textContent = 'Your device supports eSIM';
      } else if (state === 'conditional') {
        statusLabel.textContent = 'Confirmation required';
        statusTitle.textContent = 'Compatibility depends on the regional model';
      } else if (state === 'restricted') {
        statusLabel.textContent = 'Regional restriction';
        statusTitle.textContent = 'This regional version may not support travel eSIM';
      } else {
        statusLabel.textContent = 'Not compatible';
        statusTitle.textContent = 'This device does not support eSIM';
      }
    };

    const selectDevice = (device, scroll = false) => {
      selected = device;
      search.value = device.name;
      clear.hidden = false;
      suggestions.hidden = true;
      search.setAttribute('aria-expanded', 'false');
      welcome.hidden = true;
      result.hidden = false;
      renderResult();
      if (scroll) root.querySelector('.sky-checker')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const renderSuggestions = () => {
      const query = normalize(search.value);
      clear.hidden = !query;
      if (!query) { suggestions.hidden = true; search.setAttribute('aria-expanded', 'false'); return; }
      const matches = devices.filter((device) => deviceHaystack(device).includes(query)).slice(0, 8);
      suggestions.innerHTML = '';
      matches.forEach((device) => {
        const button = document.createElement('button');
        button.type = 'button'; button.setAttribute('role', 'option');
        const name = document.createElement('strong'); name.textContent = device.name;
        const meta = document.createElement('small'); meta.textContent = `${device.brand} · ${device.type === 'phone' ? 'Phone' : device.type === 'tablet' ? 'Tablet' : 'Laptop'}`;
        button.append(name, meta); button.addEventListener('click', () => selectDevice(device)); suggestions.append(button);
      });
      if (!matches.length) {
        const button = document.createElement('button'); button.type = 'button'; button.className = 'is-empty';
        const name = document.createElement('strong'); name.textContent = 'Device not found';
        const meta = document.createElement('small'); meta.textContent = 'Use the 30-second manual check';
        button.append(name, meta); button.addEventListener('click', () => { suggestions.hidden = true; root.querySelector('.sky-manual')?.scrollIntoView({ behavior: 'smooth' }); }); suggestions.append(button);
      }
      suggestions.hidden = false; search.setAttribute('aria-expanded', 'true');
    };

    search.addEventListener('input', renderSuggestions);
    search.addEventListener('focus', renderSuggestions);
    search.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { suggestions.hidden = true; search.setAttribute('aria-expanded', 'false'); }
      if (event.key === 'Enter') { const first = suggestions.querySelector('button'); if (first && !suggestions.hidden) { event.preventDefault(); first.click(); } }
    });
    clear.addEventListener('click', () => {
      selected = null; search.value = ''; clear.hidden = true; suggestions.hidden = true; result.hidden = true; welcome.hidden = false; search.focus();
    });
    document.addEventListener('click', (event) => { if (!root.querySelector('.sky-checker-search').contains(event.target)) { suggestions.hidden = true; search.setAttribute('aria-expanded', 'false'); } });
    root.querySelectorAll('[data-device-pick]').forEach((button) => button.addEventListener('click', () => {
      const query = normalize(button.dataset.devicePick);
      const device = devices.find((item) => normalize(item.name) === query) || devices.find((item) => deviceHaystack(item).includes(query));
      if (device) selectDevice(device);
    }));
    root.querySelectorAll('[name^="device-region-"]').forEach((radio) => radio.addEventListener('change', renderResult));
    cta.addEventListener('click', (event) => { if (cta.getAttribute('aria-disabled') === 'true') event.preventDefault(); });
    manualButton.addEventListener('click', () => {
      if (manualDetails) manualDetails.open = true;
      root.querySelector('.sky-manual')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    const manualTabs = [...root.querySelectorAll('[data-manual-tab]')];
    manualTabs.forEach((button) => button.addEventListener('click', () => {
      manualTabs.forEach((item) => { const active = item === button; item.classList.toggle('is-active', active); item.setAttribute('aria-selected', String(active)); });
      const content = manualContent[button.dataset.manualTab];
      root.querySelector('[data-manual-esim]').textContent = content.esim;
      root.querySelector('[data-manual-lock]').textContent = content.lock;
    }));

    const renderDirectory = () => {
      const visible = devices;
      const grouped = visible.reduce((groups, device) => { (groups[device.brand] ||= []).push(device); return groups; }, {});
      brandsRoot.innerHTML = '';
      Object.keys(grouped).sort().forEach((brand) => {
        const details = document.createElement('details');
        const summary = document.createElement('summary');
        const title = document.createElement('strong'); title.textContent = brand;
        const count = document.createElement('span'); count.textContent = `${grouped[brand].length} ${grouped[brand].length === 1 ? 'device' : 'devices'}`;
        const chevron = document.createElementNS('http://www.w3.org/2000/svg', 'svg'); chevron.setAttribute('viewBox', '0 0 16 16'); chevron.innerHTML = '<path d="m3 6 5 5 5-5"/>';
        summary.append(title, count, chevron); details.append(summary);
        const list = document.createElement('div'); list.className = 'sky-device-list__models';
        grouped[brand].sort((a,b) => a.name.localeCompare(b.name)).forEach((device) => {
          const button = document.createElement('button'); button.type = 'button';
          const name = document.createElement('span'); name.textContent = device.name;
          const badgeState = device.status === 'supported' && ((device.unsupportedRegions || []).length || device.regionNote) ? 'conditional' : device.status;
          const badge = document.createElement('em'); badge.className = `is-${badgeState}`; badge.textContent = badgeState === 'supported' ? 'Supported' : badgeState === 'unsupported' ? 'Not supported' : 'Region dependent';
          button.append(name, badge); button.addEventListener('click', () => selectDevice(device, true)); list.append(button);
        });
        details.append(list); brandsRoot.append(details);
      });
      listEmpty.hidden = visible.length > 0;
    };
    renderDirectory();
  };

  const initializeAll = (scope = document) => scope.querySelectorAll('[data-sky-device]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll());
  else initializeAll();
  document.addEventListener('skysimo:devices:ready', () => initializeAll());
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
